import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Container } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import UsersForm from "./form"
import { useLazyGetUserQuery } from "store/api/user/user.api"
import { useSelector } from "react-redux"
import { PERMISSIONS } from "helpers/roles"

const EditUsers = () => {
  const { id } = useParams()
  const [getUser, { isLoading }] = useLazyGetUserQuery()
  const [userData, setUserData] = useState()
  const [userStatus, setUserStatus] = useState()

  const { permissions } = useSelector((state) => state.user)
  const navigate = useNavigate()

  useEffect(() => {
    if (permissions.length > 0) {
      const canAccess = permissions.includes(PERMISSIONS.USER_UPDATE)
      if (!canAccess) {
        navigate("/forbidden")
      }
    }
  }, [permissions])

  useEffect(() => {
    if (id) {
      const onGetUser = async () => {
        const { data } = await getUser({ id }).unwrap()
        setUserData({
          name: data.name,
          email: data.email,
          role_id: data.role_id,
          password: "",
          confirm_password: "",
        })
        setUserStatus(data.status)
      }
      onGetUser()
    }
  }, [id])
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Edit User"} breadcrumbItem={"Edit User"} />
          {userData && (
            <UsersForm
              defaultValues={userData}
              userStatus={userStatus}
              id={id}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditUsers
